export default __webpack_public_path__ + "static/media/Jump (7).20fc25fc.png";